import React, { useEffect, useRef, useState } from 'react';
import { Content, PageContainer, TitleContainer } from './MessageReviewsPage.styles';
import { Text24Bold } from '../../../components/utils/Text/Text.styles';
import { useDispatch, useSelector } from 'react-redux';
import { ReviewDetailsModal, Table } from '../../../components';
import ReviewItem from '../../../components/Table/items/ReviewItem/ReviewItem';
import { selectFetchReviews } from '../../../store/slices/chatter/slice';
import { fetchReviews } from '../../../store/slices/chatter/asyncThunks';

const tableHeader = [
  { label: 'Chatter' },
  { label: 'Reviewer' },
  { label: 'Date' },
  { label: 'Details', type: 'action', actionWidth: 10 },
];

const MessageReviewsPage = () => {
  const dispatch = useDispatch();
  const { data, pending } = useSelector(selectFetchReviews);
  const reviewDetailsModalRef = useRef();
  const [selectedReviewId, setSelectedReviewId] = useState(null);

  useEffect(() => {
    dispatch(fetchReviews());
  }, [dispatch]);

  const onDetailsClicked = reviewId => {
    setSelectedReviewId(reviewId);
    reviewDetailsModalRef.current.show();
  };

  return (
    <PageContainer>
      <TitleContainer>
        <Text24Bold>Message Reviews</Text24Bold>
      </TitleContainer>
      <Content>
        <Table
          headerInformation={tableHeader}
          dataLoading={pending}
          totalCount={data.length}
          currentPage={1}
          perPage={data.length || 1}
          emptyDataText="No reviews yet"
          hideFooter
          fullHeight>
          {data.map(item => (
            <ReviewItem
              key={item.id}
              chatter={item.chatter}
              reviewer={item.reviewer}
              createdAt={item.createdAt}
              seen={item.seen}
              onDetailsClicked={() => onDetailsClicked(item.id)}
            />
          ))}
        </Table>
      </Content>
      <ReviewDetailsModal
        modalRef={reviewDetailsModalRef}
        reviewId={selectedReviewId}
        onClose={() => setSelectedReviewId(null)}
      />
    </PageContainer>
  );
};

export default MessageReviewsPage;
